/**
 * Features:
 * - §14.4.5 shop-thumbnail fallback: storefront with awning, door and display
 *   window. Square frame suits the 1:1 shop-choice slot.
 */
import {
  ILLUSTRATION_ACCENT,
  PortalIllustration,
  type PortalIllustrationProps,
} from './portal-illustration';

type Props = Omit<PortalIllustrationProps, 'viewBox' | 'children'>;

export function StorefrontIllustration(props: Props) {
  return (
    <PortalIllustration viewBox="0 0 96 96" {...props}>
      {/* facade */}
      <path d="M14 30h68v54H14z" />
      {/* awning */}
      <path d="M10 30l4-12h68l4 12" />
      <path d="M10 30a6 6 0 0 0 12 0 6 6 0 0 0 12 0 6 6 0 0 0 12 0 6 6 0 0 0 12 0 6 6 0 0 0 12 0 6 6 0 0 0 12 0" />
      {/* door */}
      <path d="M22 84V48h16v36" />
      <circle cx="34" cy="66" r="1.4" stroke={ILLUSTRATION_ACCENT} />
      {/* display window + cigar shelf hint */}
      <rect x="46" y="46" width="28" height="24" />
      <path d="M50 56h20M50 62h20" />
      {/* hanging sign */}
      <path d="M74 12v-6h12v10" stroke={ILLUSTRATION_ACCENT} />
      <circle cx="80" cy="12" r="3.5" stroke={ILLUSTRATION_ACCENT} />
      {/* pavement */}
      <path d="M8 88h80" />
    </PortalIllustration>
  );
}
